import { render, staticRenderFns } from "./Impress.vue?vue&type=template&id=86a247cc&scoped=true&"
import script from "./Impress.vue?vue&type=script&lang=js&"
export * from "./Impress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a247cc",
  null
  
)

export default component.exports